// extracted by mini-css-extract-plugin
export default {"backdrop":"styles_backdrop__CRU5b","modal":"styles_modal__L1nIK"};